import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { ComplianceStatus, quoteLineType } from '../../types'
import './ScrmWarningDialog.css'

export default function ScrmWarningDialog({
  lineItems,
  onClose,
  onImport,
}: {
  lineItems: quoteLineType[] | null
  onClose: () => void
  onImport: () => void
}) {
  const nonCompliant = Array.from(
    new Set(
      (lineItems ?? [])
        .filter(item => item.Scrm === ComplianceStatus.NotCompliant)
        .map(
          item => `${item.Manufacturer ?? 'Unknown Manufacturer'} (Supplier: ${item.Provider ?? 'Unknown Supplier'})`,
        ),
    ),
  )

  return (
    <Dialog open={lineItems !== null} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle className="scrm-warning-dialog-title">
        <span>
          <span className="scrm-warning-dialog-warning">Warning</span>: Not SCRM Compliant
        </span>
        <IconButton size="small" onClick={onClose} aria-label="Close">
          <Close fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          The following Suppliers/Manufacturers are not SCRM compliant:
          <Box component="ul" marginY={1} paddingLeft={3}>
            {nonCompliant.map(entry => (
              <li key={entry}>
                <strong>{entry}</strong>
              </li>
            ))}
          </Box>
          This imported supplier quote will fail to pass validation. Request or Add a new Supplier/Manufacturer by using
          the buttons below. Do you want to continue importing?
        </DialogContentText>
      </DialogContent>
      <DialogActions className="scrm-warning-dialog-actions">
        <Button variant="outlined" onClick={() => window.open('/suppliermanagement/supplier', '_blank')}>
          Request New Supplier
        </Button>
        <Button variant="outlined" onClick={() => window.open('/suppliermanagement/manufacturer', '_blank')}>
          Add New Manufacturer
        </Button>
        <Button variant="contained" onClick={onImport}>
          Import Quote
        </Button>
      </DialogActions>
    </Dialog>
  )
}
